module.exports = __webpack_public_path__ + "img/chengguozh2.abfe1644.webp";